import { LoadingComponentProps } from '@/types/other';
import React from 'react';

const LoadingComponent = <T extends React.ElementType = 'div'>({
  children,
  loading,
  as,
  componentProps,
  loadingComp,
  keepContainer = true,
}: LoadingComponentProps<T>) => {
  const Component = as || 'div';
  if (typeof children === 'string' && !loadingComp && loading) {
    return (
      <Component
        {...componentProps}
        className={getClassName<T>(loading, componentProps)}
      >
        <span className="!tw-text-transparent">{children}</span>
      </Component>
    );
  }
  if (loading || keepContainer) {
    return (
      <Component
        {...componentProps}
        className={getClassName<T>(loading, componentProps)}
      >
        {loadingComp ? loadingComp : children}
      </Component>
    );
  }

  return <>{children}</>;
};

function getClassName<T extends React.ElementType>(
  loading: boolean,
  componentProps: LoadingComponentProps<T>['componentProps']
) {
  if (loading) {
    return componentProps?.className
      ? `${componentProps.className} loading-skeleton`
      : 'loading-skeleton';
  }
  return componentProps?.className || '';
}

export default LoadingComponent;
